import { useEffect } from 'react';

import { createNotification } from '../helpers';
import { ErrorProps, NotificationState } from '../types';

type UseErrorProps = NotificationState & ErrorProps & {};

const useErrorNotification = ({
  isError,
  errorTitle,
  notifications,
  errorMessage,
  setNotifications
}: UseErrorProps) => {
  useEffect(() => {
    const canShowError = isError && errorMessage;

    if (!canShowError) return;

    const newNotification = createNotification({
      notifications,
      setNotifications,
      type: 'error',
      title: errorTitle,
      description: errorMessage
    });
    const newNotifications = [...notifications, newNotification];

    setNotifications(newNotifications);
  }, [isError]);
};

export default useErrorNotification;
